module.exports = __webpack_public_path__ + "media/images/logo-87b8c862.png";